import { createReducer, on, Action } from '@ngrx/store';
import { AuthState } from '@/app/shared/interfaces';
import { updateAuthChallengeToken } from './auth.actions';
import * as AuthActions from './auth.actions';
import { initialAuthState } from './auth.state';

export const authReducer = createReducer(
    initialAuthState,

    on(AuthActions.login, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(AuthActions.loginSuccess, (state, { accessToken, refreshToken, authChallengeToken, challenge }) => ({
        ...state,
        isLoading: false,
        tokens:
            accessToken && refreshToken
                ? {
                      accessToken,
                      refreshToken,
                  }
                : null,
        challenge: {
            authChallengeToken,
            challengeType: challenge?.type || null,
            challengeReason: challenge?.reason || null,
            challengeDelivery: challenge?.delivery || null,
            details: challenge?.details || null,
        },
        isLoggedIn: !!accessToken,
        error: null,
    })),

    on(AuthActions.loginFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    on(AuthActions.initiateMfaSetup, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(AuthActions.initiateMfaSetupSuccess, (state, { authChallengeToken, challenge, otpAuthUri, secretKey }) => ({
        ...state,
        isLoading: false,
        challenge: {
            authChallengeToken,
            challengeType: challenge?.type || null,
            challengeReason: challenge?.reason || null,
            challengeDelivery: challenge?.delivery || null,
            otpAuthUri,
            secretKey,
            details: challenge?.details || null,
        },
        error: null,
    })),

    on(AuthActions.initiateMfaSetupFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    on(AuthActions.verifyMfaCode, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(AuthActions.verifyMfaCodeSuccess, (state, { authChallengeToken, challenge }) => ({
        ...state,
        isLoading: false,
        challenge: {
            authChallengeToken,
            challengeType: challenge?.type || null,
            challengeReason: challenge?.reason || null,
            challengeDelivery: challenge?.delivery || null,
            details: challenge?.details || null,
        },
        error: null,
    })),

    on(AuthActions.verifyMfaCodeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    on(AuthActions.verifyDevice, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(AuthActions.verifyDeviceSuccess, (state, { authChallengeToken, challenge }) => ({
        ...state,
        isLoading: false,
        challenge: {
            authChallengeToken,
            challengeType: challenge?.type || null,
            challengeReason: challenge?.reason || null,
            challengeDelivery: challenge?.delivery || null,
            details: challenge?.details || null,
        },
        error: null,
    })),

    on(AuthActions.verifyDeviceFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    on(AuthActions.completeLogin, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(AuthActions.completeLoginSuccess, (state, { accessToken, refreshToken, authChallengeToken, challenge }) => ({
        ...state,
        isLoading: false,
        tokens:
            accessToken && refreshToken
                ? {
                      accessToken,
                      refreshToken,
                  }
                : null,
        challenge: {
            authChallengeToken,
            challengeType: challenge?.type || null,
            challengeReason: challenge?.reason || null,
            challengeDelivery: challenge?.delivery || null,
            details: challenge?.details || null,
        },
        isLoggedIn: !!accessToken,
        error: null,
    })),

    on(AuthActions.completeLoginFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    on(AuthActions.loadUserProfile, (state) => ({
        ...state,
        error: null,
    })),

    on(AuthActions.loadUserProfileSuccess, (state, { user }) => ({
        ...state,
        user,
        isLoggedIn: true,
        error: null,
        initialized: true,
    })),

    on(AuthActions.loadUserProfileFailure, (state, { error }) => ({
        ...state,
        error,
        initialized: true,
    })),

    on(AuthActions.refreshToken, (state) => ({
        ...state,
        error: null,
    })),

    on(AuthActions.refreshTokenSuccess, (state, { accessToken, refreshToken }) => ({
        ...state,
        isLoading: false,
        tokens:
            accessToken && refreshToken
                ? {
                      accessToken,
                      refreshToken,
                  }
                : null,
        isLoggedIn: true,
        error: null,
    })),

    on(AuthActions.refreshTokenFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    on(AuthActions.logout, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(AuthActions.logoutSuccess, () => ({
        ...initialAuthState,
        initialized: true,
    })),

    on(AuthActions.logoutFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    on(AuthActions.clearChallenge, (state) => ({
        ...state,
        challenge: {
            authChallengeToken: null,
            challengeType: null,
            challengeReason: null,
            challengeDelivery: null,
            details: null,
        },
        error: null,
    })),

    on(AuthActions.restoreChallengeState, (state, { authChallengeToken, challenge }) => ({
        ...state,
        challenge: {
            authChallengeToken,
            challengeType: challenge?.type || null,
            challengeReason: challenge?.reason || null,
            challengeDelivery: challenge?.delivery || null,
            details: challenge?.details || null,
        },
        error: null,
    })),

    on(AuthActions.appLoaded, (state) => ({
        ...state,
        initialized: true,
    })),

    on(AuthActions.changeMfaMethod, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(AuthActions.changeMfaMethodSuccess, (state, { authChallengeToken, challenge }) => ({
        ...state,
        isLoading: false,
        challenge: {
            authChallengeToken,
            challengeType: challenge?.type || null,
            challengeReason: challenge?.reason || null,
            challengeDelivery: challenge?.delivery || null,
            details: challenge?.details || null,
        },
        error: null,
    })),

    on(AuthActions.changeMfaMethodFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    on(AuthActions.clearError, (state) => ({
        ...state,
        error: '',
    })),

    on(AuthActions.changePassword, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(AuthActions.changePasswordSuccess, (state, { authChallengeToken, challenge }) => ({
        ...state,
        isLoading: false,
        challenge: {
            authChallengeToken,
            challengeType: challenge?.type || null,
            challengeReason: challenge?.reason || null,
            challengeDelivery: challenge?.delivery || null,
            details: challenge?.details || null,
        },
        error: null,
    })),

    on(AuthActions.changePasswordFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    on(AuthActions.skipPasswordChange, (state) => ({
        ...state,
    })),

    on(AuthActions.updateAuthChallengeToken, (state, { authChallengeToken }) => ({
        ...state,
        challenge: {
            ...state.challenge,
            authChallengeToken,
        },
    })),

    on(AuthActions.initiateChallengeVerification, (state, { authChallengeToken, challenge }) => ({
        ...state,
        isLoading: false,
        challenge: {
            authChallengeToken,
            challengeType: challenge?.type || null,
            challengeReason: challenge?.reason || null,
            challengeDelivery: challenge?.delivery || null,
            details: challenge?.details || null,
        },
        error: null,
    })),
);

export function reducer(state: AuthState | undefined, action: Action) {
    return authReducer(state, action);
}
